import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { GroupedListItemPaper } from '../GroupedListItem';
import { styled } from '@/core/ui';
export const FullStretchPaperStyled = styled(forwardRef((props, ref) => (_jsx(GroupedListItemPaper, { ref: ref, ...props, withBackdrop: false }))))({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
});
